(function () {
        if (window.__CC26_INITED) return;
        window.__CC26_INITED = true;
        const cfg = window.CC26_CONFIG || {};
        // Pārliecinamies, ka FORM_URL ir tieši tas, kas prasīts
        const FORM_URL = cfg.FORM_URL || "https://bratus.lv/products/vasaras-nometne-2026?variant=52354627764565";
        const GIF = cfg.GIF_URLS || {};
        const URLS = cfg.IMAGE_URLS || {};
        // Izlabo trūkstošo bildi pie "Komponentes un pamati"
        URLS["micro_components"] = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/Sensoti_uz_galda.png?v=1767966069";
        URLS["camp_equipment_card"] = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/WhatsApp_Image_2026-02-02_at_14.02.00.jpg?v=1770116299";    const qs = (s, r = document) => r.querySelector(s);
        const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
        const eur = (n) => (typeof n === "number" ? `${n}€` : n);
        const img = (key) => (URLS && URLS[key]) ? URLS[key] : "";
        const root = qs("[data-cc26]");
        if (!root) return;
        const dynamicWrap = qs("#cc26-dynamic", root);
        root.addEventListener("click", (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const href = a.getAttribute("href");
            if (!href || href === "#") return;
            const target = qs(href, root) || document.querySelector(href);
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        const formLink = qs("#cc26-formLink", root);
        if (formLink) formLink.href = FORM_URL;
        qsa("[data-cc26-gif]", root).forEach(el => {
            const key = el.getAttribute("data-cc26-gif");
            if (key && GIF[key]) el.src = GIF[key];
        });
        const equipmentCamp = {
            id: "eq_all",
            tag: "", // Removed pill text
            tagClass: "",
            title: "Iekārtu nometne — CREATE CAMP",
            sessions: ["15–19 jūnijā, 2026", "10–14 augustā, 2026"],
            dates: "15–19 jūnijā, 2026 • 10-14 augustā, 2026",
            age: "8–14 gadi",
            full: 350,
            from: 305,
            discounts: [
                { name: "Atlaide visiem mūsu skolēniem", note: "no marta", price: 315 },
                { name: "Apmeklējot nometni ar draugu/māsu/brāli", note: "", price: 315 }
            ],
            imgKey: "camp_equipment_card"
        };
        const microCamp = {
            id: "micro",
            tag: "Mikroelektronikas nometne 2026",
            tagClass: "cc26-tag--cyan",
            title: "Mikroelektronikas nometne 2026",
            sessions: ["20–24 jūlijs, 2026"],
            dates: "20–24 jūlijs, 2026",
            age: "10-13 gadu grupa un 14-17 gadu grupa",
            full: 370,
            from: 320,
            discounts: [
                { name: "Atlaide visiem mūsu skolēniem", note: "no marta", price: 330 },
                { name: "Apmeklējot nometni ar draugu/māsu/brāli", note: "", price: 330 }
            ],
            imgKey: "camp_micro"
        };
        const equipmentCamps = [equipmentCamp];
        const microCamps = [microCamp];
        const pricingMap = {};
        [...equipmentCamps, ...microCamps].forEach(c => pricingMap[c.id] = c);
        const summaryBar = qs("#cc26-summaryBar", root);
        const campsTitle = qs("#cc26-campsTitle", root);
        const campsNote = qs("#cc26-campsNote", root);
        const campsList = qs("#cc26-campsList", root);
        const heroFill = qs("#cc26-heroFill", root);
        const heroMediaFill = qs("#cc26-heroMediaFill", root);
        const heroMediaImg = qs("#cc26-heroMediaImg", root);
        const cta = qs("#cc26-cta", root);
        const heroCopy = qs(".cc26-hero__copy", root);
        const heroMedia = qs(".cc26-hero__media", root);
        const ctaHome = (cta && cta.parentNode) ? { parent: cta.parentNode, next: cta.nextSibling } : null;
        /* CTA is removed in HTML, so this might not find elements, but logic kept for safety or if user adds back */
        const placeHeroCTA = (mode) => {
            if (!cta || !ctaHome || !heroMedia || !heroCopy) return;
            if (mode === "micro") {
                const miniNote = qs(".cc26-miniNote", root);
                if (miniNote && miniNote.parentNode === heroMedia) {
                    heroMedia.insertBefore(cta, miniNote.nextSibling);
                } else {
                    heroMedia.appendChild(cta);
                }
            } else {
                if (ctaHome.next && ctaHome.next.parentNode === ctaHome.parent) {
                    ctaHome.parent.insertBefore(cta, ctaHome.next);
                } else {
                    ctaHome.parent.appendChild(cta);
                }
            }
        };
        const fallbackEquipment = img("camp_equipment_1") || img("heroBg_equipment") || "";
        const fallbackMicro = img("camp_micro") || img("heroBg_micro") || fallbackEquipment || "";
        const ensureImage = (mode, key) => {
            const u = img(key);
            if (u) return u;
            return mode === "micro" ? fallbackMicro : fallbackEquipment;
        };
        const ensureGallery = (mode, arr) => {
            const a = Array.isArray(arr) ? arr.filter(Boolean) : [];
            if (a.length) return a;
            const f = mode === "micro" ? fallbackMicro : fallbackEquipment;
            return f ? [f, f, f, f] : [];
        };
        const renderCamp = (c, mode) => {
    const best = c.discounts.reduce((m, d) => (!m || d.price < m.price) ? d : m, null);
    const campImg = ensureImage(mode, c.imgKey);
    const isMicro = mode === "micro";
    const accent = isMicro ? "#c084fc" : "#f59e0b";
    const accentBg = isMicro ? "rgba(176,105,219,0.12)" : "rgba(245,158,11,0.12)";
    const accentBorder = isMicro ? "rgba(176,105,219,0.35)" : "rgba(245,158,11,0.35)";
    const accentGlow = isMicro ? "rgba(176,105,219,0.1)" : "rgba(245,158,11,0.1)";
    const badgeText = isMicro ? "⚡ Viedo sistēmu nometne" : "⚙️ STEM Iekārtu nometne";

    const sessionsHTML = (c.sessions && c.sessions.length)
        ? c.sessions.map(s => `
            <div style="display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:10px;font-size:14px;font-weight:600;flex:1;min-width:120px;">
              <span style="color:${accent};">●</span> ${s}
            </div>`).join("")
        : `<div style="font-size:14px;">${c.dates}</div>`;

    const infoRows = [
        { icon: "📅", label: "Maiņas", fullWidth: true, val: `<div style="display:flex;flex-direction:row;flex-wrap:wrap;gap:6px;">${sessionsHTML}</div>` },
        { icon: "👧", label: "Vecums", val: `<strong>${c.age}</strong>` },
        { icon: "📍", label: "Lokācija", val: "Ķekavas vsk. sākumskola, Nākotnes iela 1A" },
        { icon: "💶", label: "Cena", val: `Pilnā: <strong>${eur(c.full)}</strong> &nbsp;·&nbsp; No: <strong style="color:${accent};">${eur(best.price)}</strong> (ar atlaidi)` },
        { icon: "💳", label: "Avanss", val: "<strong>50€ avansa maksājums</strong>, visa tālākā informācija — Jūsu e-pastā" },
        { icon: "⏳", label: "Pieteikšanās", val: "<strong>01.02.2026</strong> · vietu skaits ierobežots" },
    ];

    return `
        <article style="
            background: rgba(255,255,255,0.045);
border: 1px solid rgba(255,255,255,0.1);
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 12px 40px rgba(0,0,0,0.4);
            position: relative;
        ">
          <!-- Glow -->
          <div style="position:absolute;inset:0;background:radial-gradient(ellipse at 10% 0%, ${accentGlow}, transparent 55%);pointer-events:none;border-radius:22px;"></div>

          <!-- Badge josla -->
          <div style="
            padding: 10px 24px;
            background: ${accentBg};
            border-bottom: 1px solid ${accentBorder};
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 8px;
          ">
            <span style="font-size:11px;font-weight:800;letter-spacing:0.12em;text-transform:uppercase;color:${accent};">${badgeText}</span>
            <span style="display:flex;align-items:center;gap:6px;font-size:11px;font-weight:700;color:#fbbf24;">
              <span style="width:7px;height:7px;border-radius:50%;background:#fbbf24;display:inline-block;animation:cc26blink 1.2s infinite;"></span>
              Aktīva reģistrācija
            </span>
          </div>

          <!-- Galvenais saturs -->
          <div style="display:grid;grid-template-columns:320px 1fr;min-height:340px;">

            <!-- Bilde -->
            <div style="overflow:hidden;position:relative;">
              <img src="${campImg}" alt="${c.title}" loading="lazy"
                   style="width:100%;height:100%;object-fit:cover;display:block;transition:transform 0.4s ease;">
              <!-- Cenas overlay uz bildes -->
              <div style="
                position:absolute;bottom:16px;left:16px;
                background:rgba(0,0,0,0.75);
                backdrop-filter:blur(10px);
                border:1px solid ${accentBorder};
                border-radius:14px;
                padding:10px 16px;
              ">
                <div style="font-size:11px;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.08em;margin-bottom:2px;">No</div>
                <div style="font-size:28px;font-weight:900;color:${accent};line-height:1;">${eur(best.price)}</div>
                <div style="font-size:12px;color:rgba(255,255,255,0.35);text-decoration:line-through;">${eur(c.full)}</div>
              </div>
            </div>

            <!-- Info -->
            <div style="padding:24px;display:flex;flex-direction:column;gap:0;position:relative;z-index:1;">
              <h3 style="font-size:20px;font-weight:900;color:#fff;margin:0 0 18px;line-height:1.2;">${c.title}</h3>

              <div style="display:flex;flex-direction:column;gap:8px;flex:1;">
                ${infoRows.map(row => row.fullWidth ? `
                  <div style="padding:10px 12px;background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.07);border-radius:12px;font-size:13px;">
                    <div style="text-align:center;color:rgba(255,255,255,0.45);font-weight:700;text-transform:uppercase;font-size:11px;letter-spacing:0.06em;margin-bottom:8px;">${row.icon} ${row.label}</div>
                    ${row.val}
                  </div>
                ` : `
                  <div style="display:grid;grid-template-columns:28px 100px 1fr;align-items:start;gap:8px;padding:10px 12px;background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.07);border-radius:12px;font-size:13px;">
                    <span>${row.icon}</span>
                    <span style="color:rgba(255,255,255,0.45);font-weight:700;text-transform:uppercase;font-size:11px;letter-spacing:0.06em;padding-top:1px;">${row.label}</span>
                    <span style="color:#fff;font-weight:500;line-height:1.45;">${row.val}</span>
                  </div>
                `).join("")}
              </div>

              <!-- Pogas -->
              <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:16px;">
                <button class="cc26-btn cc26-btn--ghost" type="button" data-open-price="${c.id}"
                        style="font-size:13px;padding:10px 16px;">
                  Skatīt atlaides
                </button>
                <a class="cc26-btn cc26-btn--primary"
                   href="${FORM_URL}" target="_blank" rel="noopener"
                   style="flex:1;justify-content:center;min-width:140px;${isMicro ? 'background:linear-gradient(135deg,#B069DB,#7c3aed);' : 'background:linear-gradient(135deg,#f59e0b,#d97706);color:#000;'}">
                  Pieteikties — 50€ avanss
                </a>
              </div>
            </div>

          </div>
        </article>

        <style>
          @media (max-width: 760px) {
            #cc26-campsList article > div[style*="grid-template-columns:320px"] {
              grid-template-columns: 1fr !important;
            }
            #cc26-campsList article > div[style*="grid-template-columns:320px"] > div:first-child {
              height: 220px !important;
            }
            #cc26-campsList article > div > div:last-child {
              padding: 16px !important;
            }
            #cc26-campsList article div[style*="grid-template-columns:28px"] {
              grid-template-columns: 22px 80px 1fr !important;
              font-size: 12px !important;
            }
          }
        </style>
    `;
};
        const setHeroBg = (mode) => {
            const hero = qs(".cc26-hero__bg", root);
            if (!hero) return;
            const u = ensureImage(mode, mode === "micro" ? "heroBg_micro" : "heroBg_equipment");
            if (!u) return;
            // Darkened gradient for dark mode
            const grad = mode === "micro"
                ? `radial-gradient(900px 450px at 15% 15%, rgba(109,40,217,.18), transparent 60%),
                radial-gradient(800px 420px at 85% 20%, rgba(6,182,212,.16), transparent 60%),
                radial-gradient(700px 380px at 70% 90%, rgba(236,72,153,.10), transparent 65%),
                linear-gradient(180deg, rgba(255,255,255,.88), rgba(246,247,255,.96))`
                : `radial-gradient(900px 450px at 15% 15%, rgba(255,255,255,.10), transparent 60%),
                radial-gradient(800px 420px at 85% 20%, rgba(255,255,255,.05), transparent 60%),
                linear-gradient(180deg, rgba(20,20,20,.95), rgba(30,30,30,.98))`;
            // Manually setting dark gradient since CSS vars might not be enough for background-image

            hero.style.backgroundImage = `${grad}, url("${u}")`;
            hero.style.backgroundSize = "cover";
            hero.style.backgroundPosition = "center";
        };

const setHeroTitle = (mode) => {
    const h1 = qs("#cc26-heroTitle", root);
    if (!h1) return;

    // Definējam apakšvirsrakstus P2 virsraksti
     const subMicro = ""; // Piemērs mikro nometnei Inženierzinātņu nometne, kurā 5 dienu laikā katrs dalībnieks radīs savu viedo ierīci no 0 līdz 100% – no shēmas lodēšanas līdz koda rakstīšanai ar MI.
     const subTech = ""; //Tehnoloģiju nometne, kurā teorija uzreiz pārtop praksē, ļaujot ikvienam dalībniekam pašam projektēt un izgatavot unikālus darbus, izmantojot mūsdienīgas programmvadāmās iekārtas un inženierijas paņēmienus.

    // CSS stils apakšvirsrakstam (lai tas būtu mazāks un ne trekns)
    const subStyle = "display: block; font-size: 0.5em; font-weight: bold; margin-top: 10px; font-style: italic; line-height: 1.2;";

    if (mode === "micro") {
        h1.innerHTML = `
            <b><i>IZVEIDO PATS SAVU MINI-DATORU PIECU DIENU LAIKĀ AR MIKROELEKTRONIKU!</i></b>
            <span style="${subStyle}">${subMicro}</span>
        `;
    } else {
        h1.innerHTML = `
            <b><i>IEPAZĪSTI PROGRAMMVADĀMO IEKĀRTU PASAULI AR DAŽĀDA VEIDA CNC IEKĀRTĀM!</i></b>
            <span style="${subStyle}">${subTech}</span>
        `;
    }
};

        const renderHeroFill = (mode) => {
            if (!heroFill) return;
            const isMicro = mode === "micro";

            // --- ŠEIT IELIEC SAVAS SAITES ---
            // --- MICRO NOMETNES BILDES ---
        const microLink1 = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/Plate_programma.png?v=1767966064"; 
        const microLink2 = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/Shema_2d.png?v=1767966045"; 

        // --- IEKĀRTU NOMETNES BILDES (JAUNĀS) ---
        const eqLink1 = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/WhatsApp_Image_2026-02-02_at_14.01.17_1.jpg?v=1770115899";
        const eqLink2 = "https://cdn.shopify.com/s/files/1/0720/6325/4803/files/WhatsApp_Image_2026-02-02_at_14.01.17.jpg?v=1770115899";

        // Kods izvēlas: ja ir Micro nometne, ņem Micro linkus. Ja nē (Iekārtu), ņem jaunos Eq linkus.
        const pic1 = isMicro ? microLink1 : eqLink1;
        const pic2 = isMicro ? microLink2 : eqLink2;
            const items = isMicro ? [
                { ic: "🔌", k: "Elektronika praksē", v: "Shēmu analīze, testēšana Tinkercad simulators vidē un patstāvīga plates lodēšana ar OLED GFX displeju un sensoriem." },
                { ic: "🧪", k: "Produkta radīšana", v: "Nekādu mazu uzdevumu – visa nometne ir viens liels projekts no 0 līdz 100%. Realizē savu unikālo inženiertehnisko ieceri." },
                { ic: "🏁", k: "Ierīce tavā kabatā", v: "Mājās dodies ar pabeigtu viedierīci un e-pastu tālākai koda attīstībai un pārveidošanai." },
                { ic: "🤝", k: "Dizains un MI", v: "Korpusa izstrāde ar Onshape (3D) un RDworks (lāzergriešana). Ierīces savienošana ar lietotni un koda rakstīšana ar MI asistentu." },
            ] : [
                { ic: "🛠️", k: "<b>Praktiska darbošanās</b>", v: "Ideja → dizains → izgatavošana ar iekārtām. No skices uz papīra līdz gatavam produktam, izmantojot modernas tehnoloģijas." },
                { ic: "✨", k: "<b>Sevis radīti darbi</b>", v: "Vairāki projekti un personalizēti rezultāti. Katrs dalībnieks veido unikālus darbus, kas atspoguļo viņa idejas." },
                { ic: "⚙️", k: "<b>Modernas tehnoloģijas</b>", v: "CO₂ lāzeriekārtas, 3D printeri, CNC frēze, plotergriezējs, šķiedru lāzers. Šīs visas digitālas ražošanas iekārtas iemācīsimies izmantot savā labā nometnes laikā." },
                { ic: "🏁", k: "<b>Gatavais projekts dodas mājās</b>", v: "Nometnes beigās — taustāms rezultāts līdzi. Visus izgatavotos projektus varēsi ņemt līdzi uz mājām." },
            ];
            heroFill.innerHTML = `
                <div class="cc26-heroFill__list">
                ${items.map(it => `
                <div class="cc26-heroFill__item">
                <div class="cc26-heroFill__ic" aria-hidden="true">${it.ic}</div>
                <div>
                <div class="cc26-heroFill__k">${it.k}</div>
                <div class="cc26-heroFill__v cc26-muted cc26-small">${it.v}</div>
                </div>
                </div>
                `).join("")}
                </div>
                ${isMicro ? "" : `
                <div class="cc26-heroFill__pics" aria-hidden="true">
                <img src="${pic1}" alt="" loading="lazy">
                <img src="${pic2}" alt="" loading="lazy">
                </div>`}
            `;
        };
        const setHeroRightFill = (mode) => {
            if (!heroMediaFill || !heroMediaImg) return;
            if (mode === "micro") {
                heroMediaImg.removeAttribute("src");
                return;
            }
            const u = img("hero_equipment_rightfill") || ensureImage(mode, "camp_equipment_1");
            if (u) heroMediaImg.src = u;
        };
        const setSummaryBar = (mode) => {
            if (!summaryBar) return;
            if (mode === "equipment") {
                summaryBar.classList.add("is-hidden");
                summaryBar.innerHTML = "";
                return;
            }
            summaryBar.classList.remove("is-hidden");
            summaryBar.innerHTML = `
                <span class="cc26-sPill">🎯 <strong>Mikroelektronikas Vasaras Nometne 2026</strong></span>
                <span class="cc26-sPill">📍 Ķekava: Ķekavas vsk. sākumskola, Nākotnes iela 1A</span>
                <span class="cc26-sPill">📅 20–24 jūlijs, 2026</span>
                <span class="cc26-sPill">👧🧑 10-13 gadu grupa un 14-17 gadu grupa</span>
                <span class="cc26-sPill">⭐ No <strong>${eur(320)}</strong></span>
                <span class="cc26-sPill">💶 Pilnā <strong>${eur(370)}</strong></span>
                <span class="cc26-sPill">💳 Avanss <strong>50€</strong></span>
                <span class="cc26-sPill">🗓️ Pieteikšanās <strong>01.02.2026</strong></span>
            `;
        };
        const renderCamps = (mode) => {
            if (!campsList) return;
            const isMicro = mode === "micro";
            const camps = isMicro ? microCamps : equipmentCamps;
            if (campsTitle) campsTitle.textContent = isMicro ? "Mikroelektronikas nometne (1 maiņa)" : "";
            if (campsNote) campsNote.textContent = isMicro ? "Fokuss: elektronikas pamati, shēmas un praktiski projekti." : "";
            campsList.className = "cc26-grid1";
            campsList.innerHTML = camps.map(c => renderCamp(c, mode)).join("");
            qsa("[data-open-price]", root).forEach(b => {
                b.addEventListener("click", () => {
                    setPrice(b.getAttribute("data-open-price"));
                    const el = qs("#cc26-pricing", root);
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                });
            });
        };

        let techInterval = null;

        const renderTech = (mode) => {
            const chipsEl = qs("#cc26-techChips", root);
            const gridEl = qs("#cc26-eqGrid", root);
            const tTitle = qs("#cc26-techTitle", root);
            const tLead = qs("#cc26-techLead", root);
            if (!chipsEl || !gridEl) return;

            if (techInterval) { clearInterval(techInterval); techInterval = null; }

            const isMicro = mode === "micro";
            if (tTitle) tTitle.innerHTML = isMicro 
                ? "<i><b>VIEDĀS SISTĒMAS UN MIKROELEKTRONIKA: NO IDEJAS LĪDZ PRODUKTAM</i></b>" 
                : "<i><b>DIGITĀLĀS RAŽOŠANAS IEKĀRTAS: AR KO STRĀDĀSIM NOMETNĒ?</b></i>";
            if (tLead) tLead.innerHTML = isMicro
                ? "Apgūsti pamatus robotikai un programmēšanai: <strong>komponentes → shēma → tests → gatavs projekts</strong>."
                : "Attīsti nākotnes prasmes - spied uz attēliem un uzzini vairāk par STEM iekārtām, ar kurām darbosimies nometnē!";

            const getEqImages = (key) => {
                const i1 = img(key + "_1");
                const i2 = img(key + "_2");
                const i3 = img(key + "_3");
                if (i1 && i2 && i3) return [i1, i2, i3];
                const main = img(key); 
                return [main, main, main];
            };

            const tech = isMicro ? {
                chips: ["Komponentes", "Shēmas", "Testēšana", "AI un Lietotne", "Gatavs projekts"],
                cards: [
                    { 
                        tone: "cc26-eq--cyan", 
                        title: "🔌 Detaļu atlase", 
                        desc: "Atlasām sensorus un detaļas tieši tavam projektam – spēļu konsolei, viedajam podam vai savai unikālajai idejai.", 
                        imgKey: "micro_components",
                        details: "<span style='color:#ffffff;'>Izzināsim galvenās elektronikas sastāvdaļas (rezistorus, LED, kondensatorus, tranzistorus). Sapratīsim, kā tās darbojas, kā mērīt to vērtības un kā tās pareizi savienot, lai izpildītu konkrētu uzdevumu.</span>" 
                    },
                    { 
                        tone: "cc26-eq--lime", 
                        title: "🔧 Lodēšana un montāža", 
                        desc: "Apgūstam darbu ar lodāmuru un patstāvīgi saliekam visu elektroniku uz reālas vadības plates.", 
                        imgKey: "micro_schematics",
                        details: "<span style='color:#ffffff;'>Iemācīsimies lasīt un veidot vienkāršas elektronikas shēmas uz maketa plates (breadboard) bez lodēšanas. Galvenais fokuss uz strāvas plūsmas loģiku, paralēliem un virknes savienojumiem, kā arī uz sprieguma un strāvas drošu izmantošanu.</span>"
                    },
                    { 
                        tone: "cc26-eq--orange", 
                        title: "🐛 Inženieru kļūdu labošana", 
                        desc: "Izmantojam Tinkercad simulators un mācāmies veikt patstāvīgu debugging, lai ierīce darbotos nevainojami.", 
                        imgKey: "micro_testing",
                        details: "<span style='color:#ffffff;'>Apgūsim multimetra (digitālā mērierīce) lietošanu. Mācīsimies pārbaudīt, vai shēma darbojas kā plānots, un atrast kļūdas (debugging). Testēšana ir kritiski svarīga, lai projektu pabeigtu.</span>" 
                    },
                    { 
                        tone: "cc26-eq--purple", 
                        title: "🤖 Kods un AI asistents", 
                        desc: "Rakstām programmu Arduino IDE vidē, izmantojot MI jaudu koda pielāgošanai un funkciju izstrādei.", 
                        imgKey: "micro_miniprojects",
                        details: "<span style='color:#ffffff;'>Īsi, interaktīvi uzdevumi, kas demonstrē konkrētus elektronikas principus. Piemēram, gaismas diodes spilgtuma regulēšana ar potenciometru vai skaņas radīšana ar mazu pīkstuli. Dod tūlītēju gandarījumu un nostiprina pamatzināšanas.</span>" 
                    },
                    { 
                        tone: "cc26-eq--pink", 
                        title: "✅ Gatavs produkts", 
                        desc: "Ar Bambu Studio sagatavotas 3D detaļas un lāzergriezts korpuss. Pārnēsājama viedierīce, ko varēsi pilnveidot mājās.", 
                        imgKey: "micro_final",
                        details: "<span style='color:#ffffff;'>Nometnes kulminācija – katrs dalībnieks izveidos pilnībā funkcionējošu ierīci (piemēram, interaktīvu sensoru vai nelielu programmējamu spēli). Šis projekts paliek dalībniekam.</span>"
                    }
                ]
            } : {
                chips: ["CO₂ lāzers", "3D printeris", "Ploteris", "Šķiedru lāzers", "CNC"],
                cards: [
                    { 
                        tone: "cc26-eq--purple", 
                        title: "🔴 CO₂ lāzergriezējs", 
                        desc: "Griež un gravē (finieris, akrils u.c.). Dizains → izgatavošana.", 
                        imgKeys: getEqImages("eq_co2"),
                        details: "Īss skaidrojums par CO₂ lāzeri: Šī iekārta ir ideāla, lai ātri un precīzi grieztu vai gravētu organiskus materiālus, piemēram, finieri, akrilu, ādu, kā arī papīru. Nometnes laikā mēs apgūsim programmatūru dizainam un pašu griešanas procesu, radot personalizētus priekšmetus, piemēram, koka kastes vai uzrakstus."
                    },
                    { 
                        tone: "cc26-eq--orange", 
                        title: "🟠 3D printeris", 
                        desc: "No idejas līdz 3D izdrukai — redzam slāņus praksē.", 
                        imgKeys: getEqImages("eq_3d"),
                        details: "Īss skaidrojums par 3D printeri: Mēs mācīsimies izmantot FDM (Fused Deposition Modeling) tipa 3D printerus. Apgūsim modelēšanas pamatus (vai izmantosim gatavus modeļus) un sagatavosim tos drukāšanai (slicing). Bērni redzēs, kā digitāls dizains kļūst par taustāmu objektu slāni pa slānim."
                    },
                    { 
                        tone: "cc26-eq--lime", 
                        title: "✂️ Plotergriezējs", 
                        desc: "Uzlīmes, trafareti un dizaini. Ātrs rezultāts.", 
                        imgKeys: getEqImages("eq_plotter"),
                        details: "Īss skaidrojums par Plotergriezēju: Iemācīsimies veidot vektorgrafikas dizainu un izgriezt no vinila plēvēm dažāda veida uzlīmes vai trafaretu šablonus. Šī iekārta ir lieliska personalizēšanai un vizuāliem projektiem, nodrošinot ātru un precīzu darbu."
                    },
                    { 
                        tone: "cc26-eq--cyan", 
                        title: "⚡ Šķiedru lāzers", 
                        desc: "Precīza gravēšana un personalizācija uz metāla.", 
                        imgKeys: getEqImages("eq_fiber"),
                        details: "Īss skaidrojums par Šķiedru lāzeri: Šī jaudīgā iekārta ļauj veikt īpaši precīzu un permanentu gravēšanu uz metāla un dažiem plastmasas veidiem. Bērni iemācīsies izprast parametrus, darba drošību un materiāla reakciju, izgatavojot personalizētus metāla priekšmetus, piemēram, atslēgu piekariņus vai rotaslietas."
                    },
                    { 
                        tone: "cc26-eq--pink", 
                        title: "⚙️ CNC frēze", 
                        desc: "Precīzu detaļu apstrāde un izgatavošana ar skaidriem soļiem.", 
                        imgKeys: getEqImages("eq_cnc"),
                        details: "Īss skaidrojums par CNC frēzi: CNC (Computer Numerical Control) frēze veic materiālu apstrādi, noņemot materiālu ar rotējošu instrumentu. Mēs apgūsim G-koda pamatus (kā datoram pateikt, kur griezt) un izgatavosim sarežģītākas, precīzas detaļas no koka vai plastmasas."
                    }
                ]
            };

            chipsEl.innerHTML = tech.chips.map((t, idx) => {
                const cls = (idx % 5 === 0) ? "cc26-chip--purple"
                    : (idx % 5 === 1) ? "cc26-chip--cyan"
                    : (idx % 5 === 2) ? "cc26-chip--lime"
                    : (idx % 5 === 3) ? "cc26-chip--orange"
                    : "cc26-chip--pink";
                return `<div class="cc26-chip ${cls}">${t}</div>`;
            }).join("");

            gridEl.innerHTML = tech.cards.map((c, i) => {
                const imgs = c.imgKeys || [ensureImage(mode, c.imgKey)];
                const mainImg = imgs[0];
                const cardData = {
                    title: c.title,
                    desc: c.desc,
                    details: c.details || c.desc,
                    img: mainImg,
                    tone: c.tone
                };
                const dataCard = `data-card-details="${encodeURIComponent(JSON.stringify(cardData))}"`;
                const clickableClass = 'cc26-eq--clickable'; 
                const dataImgs = JSON.stringify(imgs).replace(/"/g, '&quot;');
                
                return `
                    <article class="cc26-eq ${c.tone} ${clickableClass}" data-tech-idx="${i}" ${dataCard}>
                    <div class="cc26-eq__img">
                        <img src="${mainImg}" alt="${c.title}" loading="lazy" data-imgs="${dataImgs}" data-curr="0">
                    </div>
                    <div class="cc26-eq__body">
                    <h3 class="cc26-h3">${c.title}</h3>
                    <p class="cc26-muted">${c.desc}</p>
                    </div>
                    </article>
                `;
            }).join("");

            qsa('.cc26-eq--clickable', gridEl).forEach(card => {
                card.addEventListener('click', openModal);
            });

            if (!isMicro) {
                techInterval = setInterval(() => {
                    qsa(".cc26-eq__img img", gridEl).forEach(img => {
                        const raw = img.getAttribute("data-imgs");
                        if (!raw) return;
                        try {
                            const imgs = JSON.parse(raw);
                            if (imgs.length > 1) {
                                let curr = parseInt(img.getAttribute("data-curr") || "0", 10);
                                curr = (curr + 1) % imgs.length;
                                img.src = imgs[curr];
                                img.setAttribute("data-curr", curr);
                            }
                        } catch (e) { }
                    });
                }, 2000);
            }
        };
        const renderBenefits = (mode) => {
            const grid = qs("#cc26-benefitGrid", root);
            const t = qs("#cc26-benefitsTitle", root);
            const l = qs("#cc26-benefitsLead", root);
            if (!grid) return;
            const isMicro = mode === "micro";
            if (t) t.innerHTML = isMicro ? "<i><b>KO JAUNIEŠI IEGŪS PIEDALOTIES MŪSU NOMETNĒ?</b></i>" : "<i><b>KO JAUNIEŠI IEGŪS PIEDALOTIES MŪSU NOMETNĒ?</b></i>";
            
            if (l) l.textContent = isMicro 
                ? "Programmvadāmas iekārtas, robotika, elektronikas pamati + ilgtermiņa pēctecība." 
                : "Digitālā ražošana, dizains, jaunas tehnoloģijas + ilgtermiņa pēctecība mājās.";
                
            // Definējam akcenta krāsu izceltajam blokam (violeta mikro, oranža iekārtām)
            const highlightColor = isMicro ? "#c084fc" : "#f59e0b";
            const highlightGlow  = isMicro ? "rgba(176,105,219,0.15)" : "rgba(245,158,11,0.15)";

            const items = isMicro ? [
                { tone: "cc26-card--cyan", icon: "🔌", title: "<b><i>C++ un MI Programmēšana</b></i>", text: "Koda rakstīšana Arduino IDE vidē, izmantojot mākslīgā intelekta asistentu loģikas, funkciju un dizaina izstrādei savai ierīcei." },
                // IZCELTAIS BLOKS (Mikro)
                { tone: "cc26-card--lime", icon: "🚀", title: "<b><i>Projekts un pēctecība mājās</b></i>", text: "Gatavais mini dators dodas mājās! Nosūtām visus mācību materiālus un programmas, lai bērni varētu turpināt eksperimentēt patstāvīgi.", isHighlighted: true },
                { tone: "cc26-card--purple", icon: "🧠", title: "<b><i>Reālas inženieru prasmes</b></i>", text: "Elektronisko shēmu lasīšana, komponenšu analīze, lodēšana un kļūdu labošana (debugging), izmantojot displejus un viedos sensorus." },
                { tone: "cc26-card--orange", icon: "📜", title: "<b><i>Sertifikāts</b></i>", text: "Nometnes noslēgumā katrs dalībnieks saņem oficiālu sertifikātu, kas apliecina apgūtās inženierijas un programmēšanas pamatiemaņas." }
            ] : [
                { tone: "cc26-card--purple", icon: "💡", title: "<b><i>Digitālās ražošanas prasmes</b></i>", text: "No idejas līdz gatavam produktam, patstāvīgi izmantojot CO2 lāzeriekārtu, 3D printeri, ploteri un CNC frēzi reālos projektos." },
                // IZCELTAIS BLOKS (Iekārtas)
                { tone: "cc26-card--cyan", icon: "🚀", title: "<b><i>Ilgtermiņa pēctecība mājās</b></i>", text: "Visi radītie darbi dodas mājās! Piedāvājam arī 3D drukas atbalstu pēc nometnes – bērni modelē mājās, mēs izprintējam par pašizmaksu.", isHighlighted: true },
                { tone: "cc26-card--lime", icon: "🤝", title: "<b><i>Komandas darbs un inovācijas</b></i>", text: "Kopīgu ideju ģenerēšana, radoša problēmu risināšana un droša, praktiska darbošanās ar modernajām tehnoloģijām atbalstošā vidē." },
                { tone: "cc26-card--orange", icon: "🏅", title: "<b><i>Sertifikāts</b></i>", text: "Nometnes noslēgumā katrs dalībnieks saņem oficiālu sertifikātu, kas apliecina dalību un apgūtās digitālās ražošanas prasmes." }
            ];
            
            grid.innerHTML = items.map(it => {
                // Ja bloks ir izcelts, pieliekam tam īpašu inline stilu rāmim un spīdumam
                const cardStyle = it.isHighlighted 
                    ? `style="border: 2px solid ${highlightColor} !important; background: rgba(255,255,255,0.07) !important; box-shadow: 0 0 25px ${highlightGlow} !important; transform: scale(1.02);"` 
                    : '';

                // Ja bloks ir izcelts, virs virsraksta parādām nelielu nozīmīti
                const badgeHtml = it.isHighlighted 
                    ? `<span style="display: inline-block; background: ${highlightColor}; color: #000; font-size: 9px; font-weight: 900; padding: 2px 8px; border-radius: 20px; margin-bottom: 8px; letter-spacing: 0.05em; text-transform: uppercase;">Papildu vērtība</span>` 
                    : '';

                return `
                    <article class="cc26-card ${it.tone}" ${cardStyle}>
                    <div class="cc26-benefit">
                    <div class="cc26-ic" aria-hidden="true">${it.icon}</div>
                    <div>
                    ${badgeHtml}
                    <h3 class="cc26-h3">${it.title}</h3>
                    <p class="cc26-muted">${it.text}</p>
                    </div>
                    </div>
                    </article>
                `;
            }).join("");
        };
        const renderDay = (mode) => {
            const day = qs("#cc26-dayGrid", root);
            const t = qs("#cc26-dayTitle", root);
            const l = qs("#cc26-dayLead", root);
            if (!day) return;
            const isMicro = mode === "micro";
            if (t) t.innerHTML = isMicro ? "<b>DIENAS PLĀNS (VIEDĀS SISTĒMAS UN MIKROELEKTRONIKA)</b>" : "<b>DIENAS PLĀNS (IEKĀRTU NOMETNE)</b>";
            if (l) l.textContent = "Pārredzama struktūra: darbnīcas + aktīvas pauzes.";
            const w1 = isMicro ? "Mikrokontrolieri un lodēšana (liela projekta sākums)" : "Tehnoloģiju darbnīca (iekārtas + dizains)";
            const w2 = isMicro ? "Produkta izstrāde (Arduino IDE + MI + korpuss)" : "Tehnoloģiju darbnīca (izgatavošana + pēcapstrāde)";
            const rows = [
                ["08:30 – 09:00", "Ierašanās nometnē"],
                ["09:15 – 09:45", "Aktīvs rīta iesākums – mostamies kopā ☀️"],
                ["09:45 – 10:15", "Brokastis"],
                ["10:15 – 12:30", w1],
                ["12:30 – 13:00", "Brīdis atpūtai"],
                ["13:00 – 14:30", "Fiziskās aktivitātes – komandu spēles"],
                ["14:30 – 15:00", "Pilnvērtīgas pusdienas"],
                ["15:00 – 17:00", w2],
                ["17:00 – 17:30", "Dienas noslēgums"]
            ];
            day.innerHTML = rows.map(([time, what]) => `
                <div class="cc26-row">
                <div class="cc26-time">${time}</div>
                <div class="cc26-what">${what}</div>
                </div>
            `).join("");
        };
        const setPrice = (id) => {
    const c = pricingMap[id] || equipmentCamps[0];
    const isMicro = id === 'micro';
    const colorClass = isMicro ? 'cc26-priceCard--micro' : 'cc26-priceCard--eq';
    const noteClass  = isMicro ? 'cc26-noteCard--micro'  : 'cc26-noteCard--eq';
    const badgeText  = isMicro ? '⚡ Viedo sistēmu nometne' : '⚙️ STEM Iekārtu nometne';

    const priceCard = qs("#cc26-pricing .cc26-priceCard", root);
    const noteCard  = qs("#cc26-pricing .cc26-noteCard",  root);

    // Krāsu klases
    if (priceCard) {
        priceCard.className = `cc26-priceCard ${colorClass}`;
        // Noņem iepriekšējo overlay, ja eksistē
const existingOverlay = priceCard.querySelector('.cc26-soldout-overlay');
if (existingOverlay) existingOverlay.remove();

// Pievieno IZPĀRDOTS overlay tikai mikro nometnes gadījumā
if (isMicro) {
    const overlay = document.createElement('div');
    overlay.className = 'cc26-soldout-overlay';
    overlay.style.cssText = 'position:absolute;inset:0;background:rgba(10,5,20,0.55);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(5px);display:flex;align-items:center;justify-content:center;font-size:clamp(28px,4vw,42px);font-weight:900;color:#ff3333 !important;letter-spacing:0.1em;text-transform:uppercase;border-radius:20px;z-index:10;pointer-events:none;';
    overlay.textContent = '🔴 IZPĀRDOTS';
    priceCard.appendChild(overlay);
}
    }
    if (noteCard) {
        noteCard.className = `cc26-noteCard ${noteClass}`;
    }

    const title = qs("#cc26-priceTitle", root);
    const meta  = qs("#cc26-priceMeta",  root);
    const big   = qs("#cc26-priceBig",   root);
    const list  = qs("#cc26-discounts",  root);

    // Badge
    let badge = qs(".cc26-priceBadge", priceCard);
    if (!badge && priceCard) {
        badge = document.createElement('div');
        badge.className = 'cc26-priceBadge';
        priceCard.insertBefore(badge, priceCard.firstChild);
    }
    if (badge) badge.textContent = badgeText;

    if (title) title.textContent = c.title;
    if (meta)  meta.textContent  = c.dates;
    if (big)   big.textContent   = eur(c.full);

    if (list) {
        list.innerHTML = c.discounts.map(d => `
            <div class="cc26-disc">
                <div>
                    <strong>${d.name}</strong>
                    ${d.note ? `<div class="cc26-muted cc26-small">${d.note}</div>` : ''}
                </div>
                <div class="cc26-priceTag">${eur(d.price)}</div>
            </div>
        `).join("");
    }

    const noteDates = qs("#note-dates", root);
    const noteAge   = qs("#note-age",   root);
    const notePrice = qs("#note-price", root);
    const bestPrice = c.discounts.reduce((min, d) => d.price < min ? d.price : min, c.full);

    if (noteDates) noteDates.textContent = c.dates;
    if (noteAge)   noteAge.textContent   = c.age;
    if (notePrice) notePrice.innerHTML   = `Pilnā: <strong>${eur(c.full)}</strong><br>Ar atlaidi no: <strong>${eur(bestPrice)}</strong>`;
};
        const renderPricingTabs = (mode) => {
            const tabs = qs("#cc26-tabs", root);
            if (!tabs) return;
            const isMicro = mode === "micro";
            const camps = isMicro ? microCamps : equipmentCamps;
            tabs.innerHTML = camps.map((c, idx) => `
                <button class="cc26-tab ${idx === 0 ? "is-on" : ""}" type="button" data-camp="${c.id}" role="tab" aria-selected="${idx === 0 ? "true" : "false"}">
                ${isMicro ? "Mikro (20–24 jūl.)" : "Iekārtu (10–14 jūn. / 15–19 jūn.)"}
                </button>
            `).join("");
            qsa("#cc26-tabs .cc26-tab", root).forEach(b => {
                b.addEventListener("click", () => setPrice(b.getAttribute("data-camp")));
            });
            setPrice(camps[0].id);
        };
        const setApplyImg = (mode) => {
            const el = qs("#cc26-applyImg", root);
            if (!el) return;
            // Swap current image placeholder with a different one.
            // I'll use 'camp_equipment_3' for Equipment mode if available, else standard.
            el.src = mode === "micro" ? fallbackMicro : (img("camp_equipment_3") || fallbackEquipment);
        };
        const gimg = qs("#cc26-gimg", root);
        const gcap = qs("#cc26-gcap", root);
        const thumbs = qs("#cc26-thumbs", root);
        const prev = qs("#cc26-prev", root);
        const next = qs("#cc26-next", root);
        const galleryWrap = qs(".cc26-gallery", root);
        let gallery = [];
        let gi = 0;
        let galleryTimer = null;
        const stopGalleryAuto = () => {
            if (galleryTimer) {
                clearInterval(galleryTimer);
                galleryTimer = null;
            }
        };
        const startGalleryAuto = () => {
            stopGalleryAuto();
            if (!gallery || gallery.length <= 1) return;
            galleryTimer = setInterval(() => {
                gi = (gi + 1) % gallery.length;
                renderGallery();
            }, 3000);
        };
        const renderGallery = () => {
            if (!gallery.length || !gimg) return;
            gimg.classList.add("is-swap");
            setTimeout(() => {
                gimg.src = gallery[gi];
                const done = () => gimg.classList.remove("is-swap");
                gimg.onload = done;
                setTimeout(done, 220);
            }, 90);
            if (gcap) gcap.textContent = `${gi + 1} / ${gallery.length}`;
            if (thumbs) {
                thumbs.innerHTML = gallery.map((u, idx) => `
                    <button class="cc26-thumb ${idx === gi ? "is-on" : ""}" type="button" aria-label="Atvērt bildi ${idx + 1}" data-idx="${idx}">
                    <img src="${u}" alt="Galerijas bilde ${idx + 1}" loading="lazy">
                    </button>
                `).join("");
                qsa(".cc26-thumb", thumbs).forEach(btn => {
                    btn.addEventListener("click", () => {
                        stopGalleryAuto();
                        gi = parseInt(btn.getAttribute("data-idx"), 10) || 0;
                        renderGallery();
                        startGalleryAuto();
                    });
                });
                const active = qs(".cc26-thumb.is-on", thumbs);
                if (active) {
                    const left = active.offsetLeft - (thumbs.clientWidth / 2) + (active.clientWidth / 2);
                    thumbs.scrollTo({ left, behavior: "smooth" });
                }
            }
        };
        const buildGallery = (mode) => {
            const raw = mode === "micro" ? (URLS.gallery_micro || []) : (URLS.gallery_equipment || []);
            gallery = ensureGallery(mode, raw);
            gi = 0;
            renderGallery();
            startGalleryAuto();
        };
        if (prev) prev.addEventListener("click", () => {
            if (!gallery.length) return;
            stopGalleryAuto();
            gi = (gi - 1 + gallery.length) % gallery.length;
            renderGallery();
            startGalleryAuto();
        });
        if (next) next.addEventListener("click", () => {
            if (!gallery.length) return;
            stopGalleryAuto();
            gi = (gi + 1) % gallery.length;
            renderGallery();
            startGalleryAuto();
        });
        if (galleryWrap) {
            galleryWrap.addEventListener("mouseenter", stopGalleryAuto);
            galleryWrap.addEventListener("mouseleave", startGalleryAuto);
        }
        const copyBtn = qs("#cc26-copy", root);
        const toast = qs("#cc26-toast", root);
        if (copyBtn) {
            copyBtn.addEventListener("click", async () => {
                try {
                    await navigator.clipboard.writeText(FORM_URL);
                    if (toast) {
                        toast.textContent = "Anketas saite nokopēta ✅";
                        setTimeout(() => toast.textContent = "", 2200);
                    }
                } catch (e) {
                    if (toast) toast.textContent = "Neizdevās nokopēt. Nokopē manuāli: " + FORM_URL;
                }
            });
        }
        let mode = "equipment";
        const setModeButtons = (m) => {
            qsa("[data-cc26-mode-btn]", root).forEach(btn => {
                const on = btn.getAttribute("data-cc26-mode-btn") === m;
                btn.classList.toggle("is-on", on);
                btn.setAttribute("aria-selected", on ? "true" : "false");
            });
        };
        const setModeClass = (m) => {
            root.classList.toggle("cc26--micro", m === "micro");
            root.classList.toggle("cc26--equipment", m === "equipment");
        };
        // --- SĀKUMS JAUNAJAI VIDEO FUNKCIJAI ---
        // --- UZLABOTA VIDEO FUNKCIJA (AR STILIEM IEKŠĀ) ---
        const setMainVideo = (mode) => {
            const videoWrap = qs(".cc26-video__ratio", root);
            const videoNote = qs(".cc26-video .cc26-small", root); // Teksts zem video
            
            if (!videoWrap) return;

            if (mode === "micro") {
                // 1. Iztīram saturu
                videoWrap.innerHTML = "";
                
                // 2. Izveidojam video elementu ar precīziem stiliem
                // Mēs liekam "position: absolute", lai tas precīzi pārklātu rāmīti
                videoWrap.innerHTML = `
                    <video 
                        controls 
                        playsinline 
                        poster="https://cdn.shopify.com/s/files/1/0720/6325/4803/files/Gemini_Generated_Image_9ohyc79ohyc79ohy.png?v=1771329910" 
                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; border-radius: 16px;">
                        <source src="https://cdn.shopify.com/videos/c/o/v/38b66109f7b24bd0b4cd21b0d4f39a27.mp4" type="video/mp4">
                    </video>
                `;
                
                if (videoNote) videoNote.textContent = "Ieskats nometnes procesā.";
                
            } else {
                // Atgriežam YouTube priekš Iekārtu nometnes (arī ar stiliem drošībai)
                videoWrap.innerHTML = `
                    <iframe 
                        src="https://www.youtube.com/embed/nSe0UL9tCbQ" 
                        title="CREATE CAMP video" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen 
                        loading="lazy"
                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 16px;">
                    </iframe>
                `;
                if (videoNote) videoNote.textContent = "Video no iepriekšējās nometnes.";
            }
        };
        // --- BEIGAS JAUNAJAI VIDEO FUNKCIJAI ---


        // === SĀKUMS: KARTĪŠU POPUP LOGIKA ===
        
        let modalOverlay = null;

        const injectModalStyles = () => {
            // Pievienojam stilus, lai nodrošinātu pacelšanas efektu, blur un modālo logu
            const style = document.createElement('style');
            style.textContent = `
                /* Hover lift effect for ALL clickable Tech Cards */
                .cc26-eq--clickable {
                    cursor: pointer;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .cc26-eq--clickable:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
                }

                /* Modal Structure and Blur Effect */
                .cc26-modal-open > *:not(.cc26-modal__overlay) {
                    filter: blur(4px);
                    pointer-events: none;
                    transition: filter 0.3s ease;
                }
                
                .cc26-modal-open {
                    overflow: hidden;
                }
                
                .cc26-modal__overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10000;
                    padding: 20px;
                    overflow-y: auto;
                    opacity: 0;
                    animation: fadeIn 0.3s forwards;
                }
                
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                .cc26-modal {
                    background-color: white;
                    border-radius: 16px;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
                    max-width: 600px;
                    width: 100%;
                    position: relative;
                    transform: scale(0.95);
                    animation: scaleIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                    padding: 30px;
                }
                
                @keyframes scaleIn {
                    from { transform: scale(0.95); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }
                
                .cc26-modal__close {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 10px;
                    border-radius: 8px;
                    z-index: 10001;
                }
                .cc26-modal__close:hover {
                    background-color: rgba(0, 0, 0, 0.05);
                }
                
                .cc26-modal__close svg {
                    width: 24px;
                    height: 24px;
                    stroke: #333; /* Ensure color contrast */
                }

                .cc26-modal__header img {
                    width: 100%;
                    max-height: 250px;
                    object-fit: cover;
                    border-radius: 12px;
                    margin-bottom: 20px;
                }
                
                .cc26-modal__title {
                    margin-top: 0;
                    font-size: 1.5rem;
                    margin-bottom: 10px;
                }
                
                .cc26-modal .cc26-btn {
                    margin-top: 20px;
                    width: 100%;
                    text-align: center;
                }

                /* Dark mode adjustments for micro theme */
                .cc26--micro .cc26-modal {
                    background-color: #272733; 
                    color: #f0f0f0;
                }
                .cc26--micro .cc26-modal p {
                    color: #c0c0c0;
                }
                .cc26--micro .cc26-modal__close svg {
                    stroke: #f0f0f0;
                }
                .cc26--micro .cc26-modal__close:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                }
                
                /* Ensure close button contrast on light backgrounds */
                .cc26--equipment .cc26-modal__close svg {
                    stroke: #333; 
                }
/* --- INTENSĪVĀKA PULSĀCIJA (SIRDSPUKSTS) --- */
@keyframes cc26Pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
    }
    10% {
        transform: scale(1.12); /* Palielinās daudz jūtāmāk */
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3); /* Lielāka ēna */
    }
    20% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
    30% {
        transform: scale(1.12); /* Otrs ātrais pulss */
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    }
    40% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
    100% {
        transform: scale(1); /* Pārējo laiku stāv mierā */
    }
}

/* Piemērojam animāciju primārajām pogām */
.cc26-btn--primary {
    animation: cc26Pulse 2.5s infinite ease-in-out; /* Samazināju uz 2.5s lielākai dinamikai */
    transform-origin: center;
    will-change: transform, box-shadow;
}

/* Kad uzbrauc ar peli, pārtraucam pulsēšanu, lai netraucētu */
.cc26-btn--primary:hover {
    animation: none;
    transform: scale(1.08); /* Nedaudz lielāks arī hover stāvoklī */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}
            `;
            document.head.appendChild(style);
        };

        const createModalHTML = (data) => {
            return `
                <div class="cc26-modal__overlay" id="cc26-modalOverlay">
                    <div class="cc26-modal ${data.tone}">
                        <button class="cc26-modal__close" aria-label="Aizvērt">
                            <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </button>
                        <div class="cc26-modal__content">
                            <div class="cc26-modal__header">
                                <img src="${data.img}" alt="${data.title}" loading="eager">
                            </div>
                            <div class="cc26-modal__body">
                                <h2 class="cc26-modal__title" style="color: #000 !important; font-weight: 800; font-size: 32px; line-height: 1.1;">${data.title}</h2>
                                <p class="cc26-modal__desc" style="color: #000 !important;">${data.details}</p>
                                <a class="cc26-btn cc26-btn--primary" href="${FORM_URL}" target="_blank" rel="noopener">Pieteikties nometnei</a>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        };

        const closeModal = () => {
            if (modalOverlay) {
                document.removeEventListener('keydown', handleEscClose);
                root.classList.remove('cc26-modal-open');
                
                // Animation out (optional, simplified removal here)
                modalOverlay.remove();
                modalOverlay = null;
            }
        };

        const handleEscClose = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };
        
        const openModal = (e) => {
            const card = e.currentTarget;
            const rawData = card.getAttribute('data-card-details');
            if (!rawData) return;
            
            let data;
            try {
                // Decode the data attribute contents and parse JSON
                const jsonString = decodeURIComponent(rawData); 
                data = JSON.parse(jsonString);
            } catch (error) {
                console.error("Error parsing card details:", error);
                return;
            }

            if (modalOverlay) closeModal(); 

            const modalHtml = createModalHTML(data);
            root.insertAdjacentHTML('beforeend', modalHtml);
            modalOverlay = qs('#cc26-modalOverlay', root);
            
            if (modalOverlay) {
                root.classList.add('cc26-modal-open');
                
                // Setup close listeners
                const closeBtn = qs('.cc26-modal__close', modalOverlay);
                if (closeBtn) {
                    closeBtn.addEventListener('click', closeModal);
                }

                // Close on outside click (only if clicking the overlay itself)
                modalOverlay.addEventListener('click', (event) => {
                    if (event.target === modalOverlay) {
                        closeModal();
                    }
                });
                
                document.addEventListener('keydown', handleEscClose);
            }
        };

        // === BEIGAS: KARTĪŠU POPUP LOGIKA ===

        const rerenderAll = () => {
            setModeClass(mode);
            setModeButtons(mode);
            placeHeroCTA(mode);
            setHeroBg(mode);
            setHeroTitle(mode);
            renderHeroFill(mode);
            setHeroRightFill(mode);
            setSummaryBar(mode);
            renderCamps(mode);
            renderTech(mode);
            renderBenefits(mode);
            renderDay(mode);
            renderPricingTabs(mode);
            setApplyImg(mode);
            buildGallery(mode);
            
            setMainVideo(mode); // <--- ŠO OBLIGĀTI JĀPIEVIENO ŠEIT!
        };
        const switchMode = (nextMode) => {
            if (nextMode === mode) return;
            if (dynamicWrap) dynamicWrap.classList.add("is-fading");
            setTimeout(() => {
                mode = nextMode;
                rerenderAll();
                requestAnimationFrame(() => {
                    if (dynamicWrap) dynamicWrap.classList.remove("is-fading");
                });
            }, 180);
        };
        qsa("[data-cc26-mode-btn]", root).forEach(btn => {
            btn.addEventListener("click", () => switchMode(btn.getAttribute("data-cc26-mode-btn")));
        });
        // --- ATSAUKSMJU AUTO-SCROLL FUNKCIJA ---
        const initReviewScroll = () => {
            const track = qs('.cc26-reviews__track', root);
            if (!track) return;

            let interval;
            const speed = 3000; // 3 sekundes

            const start = () => {
                if (interval) clearInterval(interval);
                interval = setInterval(() => {
                    // Aprēķinam vienas kartītes platumu + atstarpi
                    const card = track.firstElementChild;
                    if (!card) return;
                    
                    const itemWidth = card.offsetWidth + 12; // 12 ir gap (atstarpe) no CSS
                    const maxScroll = track.scrollWidth - track.clientWidth;

                    // Ja esam tuvu beigām (ar nelielu rezervi), lecam uz sākumu
                    if (track.scrollLeft >= maxScroll - 10) {
                        track.scrollTo({ left: 0, behavior: 'smooth' });
                    } else {
                        // Citādi ritinam uz priekšu
                        track.scrollBy({ left: itemWidth, behavior: 'smooth' });
                    }
                }, speed);
            };

            const stop = () => {
                if (interval) clearInterval(interval);
            };

            // Sākam automātiski
            start();

            // Apstādinām, kad lietotājs grib lasīt (uzved peli vai pieskaras)
            track.addEventListener('mouseenter', stop);
            track.addEventListener('mouseleave', start);
            track.addEventListener('touchstart', stop, { passive: true });
            track.addEventListener('touchend', start);
        };

        // Izsaucam stilus pirms jebkā cita
        injectModalStyles();

        // Izsaucam funkciju
        initReviewScroll();
        rerenderAll();
    })();